import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import AdminLayout from './components/admin/AdminLayout';
import Admin from './pages/Admin/Admin';
import CompareCars from './pages/Admin/CompareCars';
import Login from './components/admin/Login';
import StageImport from './components/admin/StageImport';
import CarList from './components/admin/CarList';
import UpdateDeviceName from './components/admin/UpdateDeviceName';
import MessagesPage from './components/admin/MessagesPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import RecceReport from './components/admin/RecceReport';
import ReccePenalty from './components/admin/ReccePenalty';
import AdminGeofences from './components/admin/AdminGeofences';
import AdminSplitList from './components/admin/AdminSplitList';
import SafetyPointsAdmin from './pages/Admin/SafetyPointsAdmin';

function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        {/* Main Public Route - Monitoring Dashboard */}
        <Route path="/" element={<Home />} />

        {/* Login Page */}
        <Route path="/login" element={<Login />} />

        {/* Protected Admin Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/admin" element={<AdminLayout />}>
            {/* Default admin view - Dashboard with Command History */}
            <Route index element={<Admin />} />
            <Route path="history" element={<Admin />} />
            <Route path="compare" element={<CompareCars />} />
            <Route path="cars" element={<CarList />} />
            <Route path="import" element={<StageImport />} />
            <Route path="update-device" element={<UpdateDeviceName />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="recce/report" element={<RecceReport />} />
            <Route path="recce/penalty" element={<ReccePenalty />} />
            <Route path="geofences" element={<AdminGeofences />} />
            <Route path="splits" element={<AdminSplitList />} />
            <Route path="safety-points" element={<SafetyPointsAdmin />} />
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;


